var path = 'src/app/recruit-patient/recruit-patient.html';
var html = "<div page-wrapper> <h1 class=page-header>Recruit a Patient</h1> <div loading=loading> <div ui-view></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/recruit-patient/recruit-patient.html
 ** module id = 645
 ** module chunks = 0
 **/